<template>
    <NdaList v-if="!showDetails" @add="addNda" @edit="editNda" />
    <NdaDetails
        v-else
        :nda="nda"
        :backupData="backupData"
        :mode="mode"
        @save="save"
        @cancel="cancel"
    />
</template>

<script>
import { mapState, mapActions } from "vuex";
import NdaList from "./nda/NdaList.vue";
import NdaDetails from "./nda/NdaDetails.vue";
import { useBackupData } from "@/shared/utils/forms/useBackupData";

const MODE = {
    create: "create",
    edit: "edit",
};

export default {
    components: {
        NdaList,
        NdaDetails,
    },
    setup() {
        const { backupData, setBackupValue } = useBackupData({});
        return { backupData, setBackupValue };
    },
    data() {
        return {
            showDetails: false,
            mode: "",
        };
    },
    computed: {
        ...mapState("legal/ndas", ["nda"]),
    },
    methods: {
        ...mapActions("legal/ndas", [
            "addEmptyNda",
            "createNda",
            "updateNda",
            "removeFromNdas",
            "setCurrentNda",
            "replaceInNdas",
        ]),
        editNda(nda) {
            this.setCurrentNda(nda);
            this.mode = MODE.edit;
            this.setBackupValue(this.nda);
            this.showDetails = true;
        },
        addNda() {
            this.addEmptyNda();
            this.mode = MODE.create;
            this.setBackupValue(this.nda);
            this.showDetails = true;
        },
        cancel() {
            this.showDetails = false;
            if (this.mode === MODE.edit) {
                this.replaceInNdas(this.backupData);
            } else {
                this.removeFromNdas(this.nda);
            }
            this.setCurrentNda({});
            this.mode = "";
        },
        save() {
            this.showDetails = false;
            if (this.mode === MODE.edit) {
                this.updateNda(this.nda);
            } else {
                this.createNda(this.nda);
            }
            this.setCurrentNda({});
            this.mode = "";
        },
    },
};
</script>
